import React from 'react';
import './styles/Button.scss';

interface ButtonProps {
  text: string;
  onClick: () => void;
  variant: 'primary' | 'secondary';
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ text, onClick, variant, className = '' }) => {
  return (
    <button
      type='button'
      className={`button button--${variant} ${className}`}
      onClick={(e) => {
        e.stopPropagation(); // Prevent event propagation
        onClick();
      }}
    >
      {text}
    </button>
  );
};

export default Button;
